function PathDescriptions(el) {
    this.$el = $(el);

    if (this.$el.length) {
        this.setupDefaults();
        this.addListeners();

        if (this.mql.matches) {
            this.init();
        }
    }
};

PathDescriptions.prototype.setupDefaults = function () {
    this.mql = window.matchMedia('(max-width: 767px)');
    this.initialized = false;

    this.dom = {
        $listing: this.$el.find('.path-description__listing'),
        $items: this.$el.find('.path-description__item'),
        $parent: this.$el.parents('.choose-your-path__item'),
        $active: this.$el.find('.path-description__item--active')
    }
};

PathDescriptions.prototype.addListeners = function () {
    $(window).on('resize', this.debounce(this.onResize.bind(this), 100));
    this.dom.$parent.on('show-tab', this.onTabChange.bind(this));
};

PathDescriptions.prototype.init = function () {
    this.initialized = true;

    console.log(this.dom.$active.index())

    this.dom.$listing.slick({
        mobileFirst: true,
        infinite: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        initialSlide: this.dom.$active.index()
    });
};

PathDescriptions.prototype.destroy = function () {
    if(this.initialized) {
        this.initialized = false;
        this.dom.$listing.slick('unslick');
        this.dom.$listing.attr('role', null);
        this.dom.$items.attr({
            role: null,
            tabindex: null,
            'aria-describedby': null
        });
    }
};

PathDescriptions.prototype.onResize = function () {
    if (this.mql.matches) {
        this.init();
    } else {
        this.destroy();
    }
};

PathDescriptions.prototype.onTabChange = function () {
    if (this.mql.matches) {
        this.destroy();
        this.init();
    }
};

PathDescriptions.prototype.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

(function ($) {
    $('.path-description').each(function(i, el) {
        new PathDescriptions(el);
    });
})(jQuery);